import { useToast } from 'context/toast-context/ToastProvider';
import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { guestLoginAPI, login } from 'ServerAPI/serverAPI';

const TokenBasedAuth = ({ token, onAuthSuccess, onAuthFailure }) => {
    const [cookies, setCookies] = useCookies();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { showToast } = useToast();

    const handleTokenAuth = async (authToken) => {
        try {
            setLoading(true);
            const payload = {
                Authorization: `Token ${authToken}`,
            };
            setCookies("token", authToken, { secure: true, sameSite: "strict" });
            const response = await login(payload);
            console.log("response.data", response.data);
            if (response.status === 200) {
                // Store data in cookies similar to handleLogin
                setCookies("email", response.data.email, { secure: true, sameSite: "strict" });
                setCookies("name", response.data.name, { secure: true, sameSite: "strict" });
                setCookies("userId", response.data.userId, { secure: true, sameSite: "strict" });
                setCookies("roleId", response.data.role.roleId, { secure: true, sameSite: "strict" });
                setCookies("roleName", response.data.role.roleName, { secure: true, sameSite: "strict" });
                setCookies("organizationId", response.data.organizationId, { secure: true, sameSite: "strict" });
                setCookies("phoneNumber", response.data.phoneNumber, { secure: true, sameSite: "strict" });
                setCookies("department", response.data.department, { secure: true, sameSite: "strict" });
                setCookies("domain", response.data.domain, { secure: true, sameSite: "strict" });
                setCookies("features", JSON.stringify(response.data.features), { secure: true, sameSite: "strict" });
                setCookies("userManagement", response.data.userManagement, { secure: true, sameSite: "strict" });
                setCookies("userManagementId", response.data.userManagementId, { secure: true, sameSite: "strict" });
                console.log("Login succeded")
                // Navigate to dashboard
                // navigate("/dashboard/overview");

                if (onAuthSuccess) {
                    onAuthSuccess(response.data);
                }
            } else {
                showToast(response.data.message || 'Authentication failed');
            }
        } catch (error) {
            console.log("Token authentication error:", error);

            if (onAuthFailure) {
                onAuthFailure(error);
            }

            // Handle different error codes
            if (error.response?.status === 401) {
                console.log("Unauthorized access");
            } else if (error.response?.status === 404) {
                console.log("Employee not found");
            }

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (token) {
            handleTokenAuth(token);
        } else {
            setLoading(false);
        }
    }, [token]);

    return null;
};

export default TokenBasedAuth;